import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AddCredits from '../../../components/account/detail-card/add-credits'
// Actions
import { addCredits, getGoodwillCreditsForAccount } from '../../../store/actions'

const mapStateToProps = state => {
  return {
    account: state.crm.getAccountByIdResponse,
    posting: state.crm.addCreditsRetrieving,
    response: state.crm.addCreditsResponse
  }
}

const mapDispatch = dispatch => {
  return {
    addCredits: bindActionCreators(addCredits, dispatch),
    getGoodwillCreditsForAccount: bindActionCreators(getGoodwillCreditsForAccount, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatch
)(AddCredits)
